import { FiveOrSixUtpBlock } from 'shared/components/FiveOrSixUtpBlock';
import * as styles from './styles.css';
import { UTP } from './constants';
import { Wrapper } from 'shared/components/Wrapper';
import { SubTitle } from 'shared/components/SubTitle';
import { Block } from 'shared/components/Block';
import { NBSP } from 'shared/constants/symbols';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export const BlueUtpEcoSystem: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Block>
          <div className={styles['fix-width']}>
            <SubTitle
              theme="white"
              text={`Транзакционный бизнес усиливает экосистему и${NBSP}влияет${NBSP}на${NBSP}ключевые метрики роста:`}
            />
          </div>
          <FiveOrSixUtpBlock theme="white" items={UTP} />
        </Block>
      </Wrapper>
    </div>
  );
};
